import { ChangeDetectionStrategy, Component, OnInit, effect, inject } from '@angular/core';
import { CotizacionesCementoStore } from '../../../stores/cotizaciones-cemento.store';
import { CementoCotizacionApiService } from '../../../services/cemento-cotizacion-api.service';
import { CotizacionesCementoUiEffectsService } from '../ui-effects/cotizaciones-cemento-ui-effects.service';

@Component({
  selector: 'app-cotizacion-cemento-page',
  templateUrl: './cotizacion-cemento-page.component.html',
  styleUrls: ['./cotizacion-cemento-page.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    CementoCotizacionApiService,
    CotizacionesCementoStore,
    CotizacionesCementoUiEffectsService
  ]
})
export class CotizacionCementoPageComponent implements OnInit {
  readonly store = inject(CotizacionesCementoStore);
  private readonly uiEffects = inject(CotizacionesCementoUiEffectsService);

  constructor() {
    effect(() => {
      this.uiEffects.syncLoading(this.store.loading());
    });
  }

  ngOnInit(): void {
    this.store.loadCotizaciones().subscribe({
      error: () => {
        this.uiEffects.showLoadError();
      },
    });
  }
}
